export function grouped_rows(rows = [], key_fn) {
  const groups = rows.reduce((result, row) => {
    const key = key_fn(row) || 'Unassigned';
    result.set(key, [...(result.get(key) || []), row]);
    return result;
  }, new Map());

  return Array.from(groups.entries()).map(grouped_row);
}

export function sum_field(rows = [], field) {
  return Number(rows.reduce((sum, row) => sum + Number(safe_field_value(row, field) || 0), 0).toFixed(2));
}

export function first_value(values = []) {
  return values.find((value) => value !== undefined && value !== null && value !== '') || '-';
}

export function journal_hours(journal = {}) {
  return first_number(journal_hour_values(journal));
}

export function is_billable(journal = {}) {
  return !/^not billable\s*[-:]/i.test(String(journal.journal_description || '').trim());
}

export function user_name(journal = {}) {
  return [journal.user_first_name, journal.user_last_name].filter(Boolean).join(' ').trim()
    || journal.user_full_name
    || 'Unknown timekeeper';
}

export function clean_task(value = '') {
  return String(value || '').replace(/^(not billable|billable)\s*[-:]\s*/i, '').trim();
}

export function application_case_code(profile = {}) {
  return `APP-${first_value([profile.application_id, profile.latest_application_id, 'N/A'])}`;
}

export function first_clean_value(values = [], fallback = '') {
  return values.map(clean_domain_value).find(Boolean) || fallback;
}

export function profile_values(profile = {}, fields = []) {
  const entries = Object.entries(profile);
  return fields.map((field) => entry_value(entries.find(([key]) => key === field)));
}

function grouped_row([key, rows]) {
  return { key, rows };
}

function journal_hour_values(journal = {}) {
  return [duration_hours_or_null(journal_hours_display(journal)), numeric_hours(journal)];
}

function journal_hours_display(journal = {}) {
  return String(journal.hours_spent_display || '');
}

function is_duration_display(value = '') {
  return value.includes(':');
}

function duration_hours_or_null(value = '') {
  return is_duration_display(value) ? duration_hours(value) : null;
}

function duration_hours(value = '') {
  const [hours, minutes] = value.split(':').map(Number);
  return rounded_hours(Number(hours || 0) + Number(minutes || 0) / 60);
}

function numeric_hours(journal = {}) {
  return first_number([journal.hours_spent, journal.hours, 0]);
}

function rounded_hours(value) {
  return Number(value.toFixed(2));
}

function first_number(values = []) {
  const value = values
    .filter((item) => item !== null && item !== undefined && item !== '')
    .map(Number)
    .find(Number.isFinite);
  return value ?? 0;
}

function entry_value(entry = []) {
  return entry.length > 1 ? entry[1] : '';
}

function clean_domain_value(value) {
  return String(value || '').trim();
}

function safe_field_value(row = {}, field = '') {
  return entry_value(Object.entries(row).find(([key]) => key === field));
}
